import {axiosInstance, getAuthToken}  from "../utils/Client";
import {DESTINATION_INDEX, KPI_INDEX} from "../components/kpiPlanning/constants";

export default class KPIPlanningService {

    static getKPIPlanningCategories = () => {
        return axiosInstance.get(`/kpi_planning/categories/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static getDestinations = (locationId) => {
        return axiosInstance.get(`/kpi_planning/destination/list/${locationId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static getHabits = (jobTitleId) => {
        return axiosInstance.get(`/kpi_planning/habit/list/${jobTitleId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static getJobKPIs = (jobTitleId) => {
        return axiosInstance.get(`/kpi_planning/kpi/list/${jobTitleId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static getAllJobKPIs = (locationId) => {
        return axiosInstance.get(`/kpi_planning/kpi/list/all/${locationId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static addKPIPlanningItem = (itemObj, type) => {
        let url = '';
        if (type === DESTINATION_INDEX) {
            url = `/kpi_planning/destination/`;
        } else if (type === KPI_INDEX) {
            url = `/kpi_planning/kpi/`;
        } else {
            url = `/kpi_planning/habit/`;
        }
        return axiosInstance.post(url, itemObj,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static updateKPIPlanningItem = (itemObj, type) => {
        let url = '';
        if (type === DESTINATION_INDEX) {
            url = `/kpi_planning/destination/${itemObj.id}/`;
        } else if (type === KPI_INDEX) {
            url = `/kpi_planning/kpi/${itemObj.id}/`;
        } else {
            url = `/kpi_planning/habit/${itemObj.id}/`;
        }
        return axiosInstance.put(url, itemObj,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static deleteKPIPlanningItem = (itemId, type) => {
        let url = '';
        if (type === DESTINATION_INDEX) {
            url = `/kpi_planning/destination/${itemId}/`;
        } else if (type === KPI_INDEX) {
            url = `/kpi_planning/kpi/${itemId}/`;
        } else {
            url = `/kpi_planning/habit/${itemId}/`;
        }
        return axiosInstance.delete(url, 
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static getKPIList = (locationId) => {

        return axiosInstance.get(`/kpi/list/${locationId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static jobTitleList = async (locationId) => {
        return await axiosInstance.get(`/agency_job_titles/${locationId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

}



// WEBPACK FOOTER //
// ./src/services/KPIPlanningService.js